// src/config/institutions.ts
export interface SubInstitution {
  id: string;
  name: string;
  code: string;
  logo?: string; // Alt kuruma özel logo (opsiyonel)
}

export interface Institution {
  id: string;
  name: string;
  code: string;
  domain: string;
  logo: string;
  primaryColor: string;
  secondaryColor?: string;
  subInstitutions?: SubInstitution[]; // Alt kurumlar
}

export const institutions: Record<string, Institution> = {
  default: {
    id: "default",
    name: "TeknoKarne",
    // code: "MRJN572",
    // code: "HAL1555",
    code: "",
    domain: "teknokarne.net",
    logo: "/renkli_logo.png",
    primaryColor: "#fb8706",
    secondaryColor: "#6e6e6e",
  },
  ibrahimari: {
    id: "ibrahimari",
    name: "İbrahim Arı Eğitim Kurumları",
    code: "AR51451", // Ana kurum kodu
    domain: "ibrahimari.teknokarne.net",
    logo: "/ibrahimari.png",
    primaryColor: "#2E7D32",
    secondaryColor: "#4CAF50",
    subInstitutions: [
      {
        id: "ibrahimari-kurs",
        name: "İBRAHİM ARI KURS MERKEZİ",
        code: "G027245",
      },
      {
        id: "ibrahimari-ortaokul",
        name: "İBRAHİM ARI ORTAOKUL",
        code: "AR27927",
      },
      {
        id: "ibrahimari-akkent-ortaokul",
        name: "İBRAHİM ARI AKKENT ORTAOKUL",
        code: "AR991251",
      },
      {
        id: "ibrahimari-akkent-ozel",
        name: "AKKENT İBRAHİM ARI ÖZEL ÖĞRETİM",
        code: "LOGO1425",
      },
      {
        id: "ibrahimari-lise",
        name: "İBRAHİM ARI ANADOLU LİSE",
        code: "AR51451",
      },
    ],
  },
  ahmetcakan: {
    id: "ahmetcakan",
    name: "Ahmet Çakan Eğitim Kurumları",
    code: "GA551216",
    domain: "ahmetcakan.teknokarne.net",
    logo: "/renkli_logo.png",
    primaryColor: "#1565C0",
    secondaryColor: "#2196F3",
    subInstitutions: [
      {
        id: "genc-adim",
        name: "GENÇ ADIM BİLİM VE TEKNOLOJİ",
        code: "GA551216",
      },
      {
        id: "birey-fen-lisesi",
        name: "BİREY FEN LİSESİ",
        code: "GA551476",
      },
      {
        id: "birey-durusehir-kurs",
        name: "BİREY DURUŞEHİR KURS",
        code: "GA551477",
      },
      {
        id: "atakum-kucuk-seyler",
        name: "ATAKUM KÜÇÜK ŞEYLER",
        code: "GA551478",
      },
      {
        id: "birey-mimar-sinan-kurs",
        name: "BİREY MİMAR SİNAN KURS",
        code: "SB551876",
      },
    ],
  },
  okanegitim: {
    id: "okanegitim",
    name: "Okan Eğitim Kurumları",
    code: "OKAN364",
    domain: "okanegitim.teknokarne.net",
    logo: "/okanegitim.png",
    primaryColor: "#D32F2F",
    secondaryColor: "#F44336",
    subInstitutions: [
      {
        id: "okan-butik-esenyurt-yks",
        name: "OKAN BUTİK EĞİTİM ESENYURT YKS",
        code: "OKAN364",
      },
      {
        id: "okan-butik-esenyurt-ort-lgs",
        name: "OKAN BUTİK EĞİTİM ESENYURT ORT LGS",
        code: "OKAN365",
      },
      {
        id: "okan-egitim-plus-bahcesehir",
        name: "OKAN EĞİTİM PLUS BAHÇEŞEHİR",
        code: "OKAN366",
      },
      {
        id: "okan-butik-esenkent-yks",
        name: "OKAN BUTİK EĞİTİM ESENKENT YKS",
        code: "OKAN849",
      },
      {
        id: "okan-butik-beylikduzu",
        name: "OKAN BUTİK EĞİTİM BEYLİKDÜZÜ",
        code: "OKAN2017",
      },
    ],
  },
  ftest: {
    id: "ftest",
    name: "Future Test",
    code: "FTST2044",
    domain: "ftest.teknokarne.net",
    logo: "/ftest.png",
    primaryColor: "#D32F2F",
    secondaryColor: "#F44336",
    subInstitutions: [],
  },
  elitegitim: {
    id: "elitegitim",
    name: "Elit Eğitim Kurumları",
    code: "KELT306",
    domain: "elitegitim.teknokarne.net",
    logo: "/elitEgitim.png",
    primaryColor: "#fb8706",
    secondaryColor: "#6e6e6e",
    subInstitutions: [
      {
        id: "karatas-elit-kurs-merkezi-1",
        name: "KARATAŞ ELİT KURS MERKEZİ 1",
        code: "KELT306",
      },
      {
        id: "karatas-elit-kurs-merkezi-2",
        name: "KARATAŞ ELİT KURS MERKEZİ 2",
        code: "KE27662",
      },
      {
        id: "ibrahimli-elit-egitim",
        name: "İBRAHİMLİ ELİT EĞİTİM",
        code: "ELT01124",
      },
      {
        id: "fistiklik-elit-kurs-merkezi",
        name: "FISTIKLIK ELİT KURS MERKEZİ",
        code: "FEKM1097",
      },
      {
        id: "elit-gazifen-egitim-kurumları",
        name: "ELİT GAZİFEN EĞİTİM KURUMLARI",
        code: "EGFN1841",
      },
    ],
  },
  // Diğer kurumları buraya ekleyebilirsiniz
};

export const getInstitutionByDomain = (hostname: string): Institution => {
  // Ana domain kontrolü (teknokarne.net)
  if (hostname === "teknokarne.net" || hostname === "www.teknokarne.net") {
    // Ana domain için özel bir kurum objesi döndür
    return {
      ...institutions.default,
      // Ana domain için kurum kodunu boş bırak ki form gösterilsin
      code: "",
    };
  }

  // Subdomain'i al
  const parts = hostname.split(".");
  const isSubdomain = parts.length > 2;
  const subdomain = isSubdomain ? parts[0] : "";

  // Subdomain'e göre kurumu bul
  for (const key in institutions) {
    const institution = institutions[key];
    if (subdomain === key || subdomain === institution.id) {
      return institution;
    }
  }

  // Eğer subdomain bulunamazsa, varsayılan kurumu döndür
  return institutions.default;
};

export const getCurrentInstitution = (): Institution => {
  return getInstitutionByDomain(window.location.hostname);
};
